import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'content-blocks'
const verb = 'get'

export default class OspreyContentBlocksGetThumbnails extends BaseAction {
    constructor(dataKey) {
        const id = '582c3965-e457-4cf0-bbcb-f65b95f6f8b7'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getThumbnails(params) {
        this.params = Object.assign({
            fields: 'id,thumbnailUrl',
            pc: 8
        }, params)

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/content-blocks/content-blocks-get-thumbnails.js